<template>
  <div>
    <v-container class="py-16">
      <v-row justify="center">
        <v-col cols="12" md="10" lg="7">
          <div class="d-flex justify-center">
            <img
              class="logo"
              :src="files + informations.img"
              :alt="informations.name"
            />
          </div>
          <div
            class="
              font-weight-bold
              text-h4
              grey--text
              text--darken-2 text-center
              mt-16
            "
          >
            Ouvidoria
          </div>
          <v-card class="pa-4 my-6">
            <OmbudsmanForm
              :action="files + formAction"
              response-to="/obrigado"
            />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import OmbudsmanForm from "../components/forms/OmbudsmanForm.vue";

export default {
  data: () => ({
    formAction: "/rest/email/ouvidoria",
  }),
  components: { OmbudsmanForm },
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
  },
};
</script>

<style>
.logo {
  width: 100%;
  max-width: 350px;
}
</style>
